import React from "react";
import {
  Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

/**
 * Confirmation behind the Next button of a final step (same dialog as the
 * selection module's repeatability filter): ``text`` states what is fixed,
 * the confirm button (``confirmLabel``, "Finalize" by default) runs ``onConfirm``.
 */
export default function FinalizeDialog({ open, onClose, onConfirm, confirming, title, text, confirmLabel = "Finalize" }) {
  return (
    <Dialog open={open} onClose={() => { if (!confirming) onClose(); }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={confirming}
          sx={{ textTransform: "none", borderRadius: 2 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={onConfirm}
          disabled={confirming}
          startIcon={confirming ? <CircularProgress size={16} thickness={5} /> : <CheckCircleIcon />}
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: 2 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
